module.exports = __webpack_public_path__ + "static/media/client_ie_105x40px.85808416.svg";